<div class="tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-p-8 tw-text-center">
  <h3 class="tw-m-0 tw-mb-2 tw-text-xl tw-font-semibold tw-text-gray-900">This link is no longer available</h3>
  <p class="tw-m-0 tw-text-sm tw-text-gray-600">Ask the person who shared it for a new link.</p>
</div>
